import moment, { Moment } from "moment";
import { SERVER_DATE_FORMAT } from "shared/constants";
export const parseServerDate = (date: string) => {
  return moment(date, SERVER_DATE_FORMAT);
};

export const formatDateForServer = (date: Moment) => {
  return date.format(SERVER_DATE_FORMAT);
};


// WEBPACK FOOTER //
// ./src/shared/services/date.ts